import { ProductDetailsData, ProductPerformanceResponse, ProductPerformanceState } from 'components/ProductPerformance/types'

export const SET_PP_AREA_DATA = 'SET_PP_AREA_DATA'
export const SET_PP_STORE_DATA = 'SET_PP_STORE_DATA'
export const SET_PRODUCT_PERFORMANCE_LOADING = 'SET_PRODUCT_PERFORMANCE_LOADING'
export const SET_PRODUCT_PERFORMANCE_ERROR = 'SET_PRODUCT_PERFORMANCE_ERROR'
export const SET_PP_PRODUCT_DETAILS = 'SET_PP_PRODUCT_DETAILS'
export const SET_PP_PRODUCT_DETAILS_LOADING = 'SET_PP_PRODUCT_DETAILS_LOADING'
export const SET_PP_PRODUCT_DETAILS_ERROR = 'SET_PP_PRODUCT_DETAILS_ERROR'

interface SetAreaDataAction {
  type: typeof SET_PP_AREA_DATA
  payload: ProductPerformanceResponse
  groupId: string
}

interface SetStoreDataAction {
  type: typeof SET_PP_STORE_DATA
  payload: ProductPerformanceResponse
  groupId: string
}

interface SetLoadingAction {
  type: typeof SET_PRODUCT_PERFORMANCE_LOADING
  payload: boolean
}

interface SetErrorAction {
  type: typeof SET_PRODUCT_PERFORMANCE_ERROR
  payload: string
}

interface SetProductDetailsAction {
  type: typeof SET_PP_PRODUCT_DETAILS
  payload: ProductDetailsData
}

interface SetProductDetailsLoadingAction {
  type: typeof SET_PP_PRODUCT_DETAILS_LOADING
}

interface SetProductDetailsErrorAction {
  type: typeof SET_PP_PRODUCT_DETAILS_ERROR
  payload: string
}

type ProductPerformanceAction =
  | SetAreaDataAction
  | SetStoreDataAction
  | SetLoadingAction
  | SetErrorAction
  | SetProductDetailsAction
  | SetProductDetailsLoadingAction
  | SetProductDetailsErrorAction

const initialState: ProductPerformanceState = {
  areaData: null,
  areaGroupId: null,
  storeData: null,
  storeGroupId: null,
  isLoading: false,
  error: null,
  productDetailsData: null,
  productDetailsLoading: false,
  productDetailsError: null,
}

export const productPerformanceReducer = (
  state: ProductPerformanceState = initialState,
  action: ProductPerformanceAction
): ProductPerformanceState => {
  switch (action.type) {
    case SET_PRODUCT_PERFORMANCE_LOADING:
      return { ...state, isLoading: action.payload, error: null }
    case SET_PP_AREA_DATA:
      return { ...state, areaData: action.payload, areaGroupId: action.groupId, isLoading: false, error: null }
    case SET_PP_STORE_DATA:
      return { ...state, storeData: action.payload, storeGroupId: action.groupId, isLoading: false, error: null }
    case SET_PRODUCT_PERFORMANCE_ERROR:
      return { ...state, error: action.payload, isLoading: false }
    case SET_PP_PRODUCT_DETAILS_LOADING:
      return { ...state, productDetailsLoading: true, productDetailsError: null, productDetailsData: null }
    case SET_PP_PRODUCT_DETAILS:
      return { ...state, productDetailsData: action.payload, productDetailsLoading: false }
    case SET_PP_PRODUCT_DETAILS_ERROR:
      return { ...state, productDetailsError: action.payload, productDetailsLoading: false }
    default:
      return state
  }
}
